import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { APP_FLOW } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';

/**
 * list AppFlowDetailArgument.
 * @returns {Promise} - A promise that resolves with the list of AppFlowDetailArgument or rejects with an error.
 * @param props
 */
export const listFlows = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {

  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${APP_FLOW}/filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }

  return {
    flows: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Application Flow.
 * @returns {Promise} - A promise that resolves with the creation of Application Flow or rejects with an error.
 * @param data
 */
export const createFlow = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Application Flow.
 * @returns {Promise} - A promise that resolves with the update of Application Flow or rejects with an error.
 * @param data
 */
export const updateFlow = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Application Flow.
 * @returns {Promise} - A promise that resolves with the update of Application Flow or rejects with an error.
 * @param data
 */
export const deleteFlow = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW}?prodId=${encodeURIComponent(data?.uc_ossi_prod_id)}&afId=${encodeURIComponent(data?.uc_ossi_af_id)}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

/**
 * get copy APP Flow Data.
 * @returns {Promise} - A promise that resolves with the get of APP Flow data or rejects with an error.
 * @param data
 */
export const getCopyFlow = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW}/Copy?tenant_id=${data?.tenant_id}&uc_ossi_af_id=${encodeURIComponent(data?.uc_ossi_af_id)}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
/**
 * post copy APP Flow Data and save in DB.
 * @returns {Promise} - A promise that resolves with the create of APP Flow Data or rejects with an error.
 * @param data
 */
export const postCopyFlow = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APP_FLOW}/Copy`,
    method: 'POST',
    body: data,
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
